'use client';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const sections = [
  {
    number: '1',
    title: 'Coleta de Informações',
    content: [
      'Podemos coletar as seguintes informações fornecidas pelo usuário: nome, e-mail, mensagens enviadas através de formulários e dados fornecidos voluntariamente.',
      'Também coletamos informações automaticamente, como endereço IP, tipo de navegador, páginas acessadas e tempo de navegação.',
      'Essas informações ajudam a melhorar a experiência na plataforma.',
    ],
  },
  {
    number: '2',
    title: 'Uso das Informações',
    content: [
      'Os dados coletados podem ser utilizados para melhorar a experiência do usuário, responder mensagens ou solicitações, enviar comunicações relacionadas à plataforma e melhorar conteúdos e funcionalidades do site.',
      'A plataforma não vende, aluga ou compartilha dados pessoais com terceiros para fins comerciais.',
    ],
  },
  {
    number: '3',
    title: 'Cookies',
    content: [
      'A plataforma pode utilizar cookies para melhorar o desempenho do site, entender padrões de navegação e oferecer melhor experiência ao usuário.',
      'O usuário pode desativar cookies nas configurações do navegador.',
    ],
  },
  {
    number: '4',
    title: 'Proteção de Dados',
    content: [
      'Adotamos medidas de segurança para proteger as informações dos usuários contra acesso não autorizado, alteração, divulgação e destruição de dados.',
      'Mesmo assim, nenhum sistema online é completamente imune a riscos.',
    ],
  },
  {
    number: '5',
    title: 'Direitos do Usuário',
    content: [
      'De acordo com a LGPD, o usuário pode solicitar: acesso aos seus dados pessoais, correção de dados incompletos ou incorretos, exclusão de dados pessoais e informações sobre tratamento de dados.',
      'Solicitações podem ser feitas através do e-mail de contato da plataforma.',
    ],
  },
  {
    number: '6',
    title: 'Links para Terceiros',
    content: [
      'A plataforma pode conter links para sites externos.',
      'A 1 dia de cada vez não é responsável pelas políticas de privacidade desses sites.',
    ],
  },
  {
    number: '7',
    title: 'Alterações na Política',
    content: [
      'Esta Política de Privacidade pode ser atualizada periodicamente para refletir mudanças na legislação ou melhorias da plataforma.',
    ],
  },
  {
    number: '8',
    title: 'Contato',
    content: [
      'Para dúvidas sobre esta Política de Privacidade ou sobre seus dados pessoais, entre em contato:',
    ],
    email: 'lutecontraovicio@gmail.com',
  },
];

export default function PoliticaDePrivacidadePage() {
  const [scrollY, setScrollY] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ backgroundColor: '#1A1A2E', color: '#F8F7F4' }}>
      {/* NAV */}
      <nav
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 transition-all duration-300"
        style={{
          backgroundColor: scrollY > 40 ? 'rgba(26,26,46,0.95)' : 'transparent',
          backdropFilter: scrollY > 40 ? 'blur(12px)' : 'none',
          borderBottom: scrollY > 40 ? '1px solid rgba(196,168,130,0.15)' : 'none',
        }}
      >
        <Link href="/">
          <Image
            src="/assets/images/logo_1dia_transparente-1777268210110.png"
            alt="1 Dia de Cada Vez"
            width={120}
            height={40}
            className="object-contain"
            style={{ maxHeight: '38px' }}
          />
        </Link>
        <Link
          href="/sign-up-login"
          className="px-5 py-2 rounded-xl text-sm font-semibold transition-all duration-200 hover:scale-105"
          style={{ backgroundColor: '#7C9E87', color: '#fff' }}
        >
          Quero Sair Disso
        </Link>
      </nav>
      {/* Background blobs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full opacity-10 blur-3xl"
          style={{ backgroundColor: '#C4A882' }}
        />
        <div
          className="absolute bottom-1/3 left-1/4 w-80 h-80 rounded-full opacity-8 blur-3xl"
          style={{ backgroundColor: '#7C9E87' }}
        />
      </div>
      {/* Content */}
      <main
        className="relative z-10 max-w-2xl mx-auto px-6 pt-32 pb-24"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 0.6s cubic-bezier(0.22,1,0.36,1), transform 0.6s cubic-bezier(0.22,1,0.36,1)',
        }}
      >
        {/* Header */}
        <div className="mb-12">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase mb-4 px-3 py-1 rounded-full"
            style={{ backgroundColor: 'rgba(196,168,130,0.15)', color: '#C4A882' }}
          >
            Plataforma 1 dia de cada vez
          </span>
          <h1
            className="text-4xl md:text-5xl font-bold leading-tight mb-3"
            style={{ color: '#F8F7F4' }}
          >
            Política de Privacidade
          </h1>
          <p className="text-sm mb-4" style={{ color: 'rgba(248,247,244,0.45)' }}>
            Última atualização: Abril de 2026
          </p>
          <div className="w-16 h-1 rounded-full" style={{ backgroundColor: '#7C9E87' }} />
        </div>

        {/* LGPD intro */}
        <div
          className="mb-10 p-5 rounded-2xl border"
          style={{
            backgroundColor: 'rgba(196,168,130,0.07)',
            borderColor: 'rgba(196,168,130,0.2)',
          }}
        >
          <p className="text-base leading-relaxed" style={{ color: 'rgba(248,247,244,0.82)' }}>
            A <strong style={{ color: '#F8F7F4' }}>1 dia de cada vez</strong> respeita a privacidade dos usuários e está comprometida com a proteção dos dados pessoais conforme a{' '}
            <strong style={{ color: '#C4A882' }}>Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018)</strong>.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-10">
          {sections?.map((section) => (
            <div key={section?.number}>
              <div className="flex items-center gap-3 mb-4">
                <span
                  className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
                  style={{ backgroundColor: 'rgba(196,168,130,0.2)', color: '#C4A882' }}
                >
                  {section?.number}
                </span>
                <h2 className="text-lg font-semibold" style={{ color: '#F8F7F4' }}>
                  {section?.title}
                </h2>
              </div>
              <div className="pl-10 space-y-3">
                {section?.content?.map((para, i) => (
                  <p
                    key={i}
                    className="text-base leading-relaxed"
                    style={{ color: 'rgba(248,247,244,0.78)' }}
                  >
                    {para}
                  </p>
                ))}
                {section?.email && (
                  <a
                    href={`mailto:${section?.email}`}
                    className="inline-block text-sm font-medium transition-opacity hover:opacity-80"
                    style={{ color: '#7C9E87' }}
                  >
                    {section?.email}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Footer links */}
        <div
          className="mt-14 pt-8 flex flex-wrap gap-4 justify-center"
          style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
        >
          {[
            { href: '/', label: '← Início' },
            { href: '/quem-somos', label: 'Quem Somos' },
            { href: '/termos-de-uso', label: 'Termos de Uso' },
            { href: '/seja-voluntario', label: 'Contato' },
          ]?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              className="text-sm transition-opacity hover:opacity-80"
              style={{ color: 'rgba(248,247,244,0.4)' }}
            >
              {link?.label}
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
